module.exports = __webpack_public_path__ + "static/media/foodprint_app4_preview.84f99e83.jpg";